// @ts-check
import React, { useState, useCallback } from 'react';
import QuestionMarkCircleIcon from '@heroicons/react/outline/QuestionMarkCircleIcon';
import api from 'utils/api';
import { useQuery } from 'react-query';
import { HelpModal } from './HelpModal';

/** @typedef {{
}} HelpWidgetProps */

/** @type { React.FC<HelpWidgetProps> } */
export const HelpWidget = () => {
  const [activeModal, setActiveModal] = useState(null);
  const closeModal = useCallback(() => setActiveModal(null), []);

  const { data } = useQuery('custom-help-widget', () =>
    api.get('/agent_portal/api/custom_help_widget').then((resp) => resp.data)
  );

  const customHelpWidget = data && data.customHelpWidget;

  /* eslint-disable */
  return customHelpWidget ? (
    <>
      <HelpModal
        isOpen={activeModal && activeModal.modal === 'HELP'}
        onClose={closeModal}
        customHelpWidget={activeModal && activeModal.customHelpWidget}
      />
      <div
        role="button"
        className="HelpWidget hover:bg-blue-600 flex items-center p-3 text-lg font-semibold text-white transition-colors duration-200 bg-blue-500 rounded-full shadow-lg cursor-pointer"
        onClick={() => setActiveModal({ modal: 'HELP', customHelpWidget })}
      >
        <QuestionMarkCircleIcon className="w-6 h-6 mr-2" />
        Help
      </div>
    </>
  ) : null;
  /* eslint-enable */
};
